import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Support from './pages/Support';
import Open from './pages/Open';
import Invite from './pages/Invite';
import VenueLink from './pages/VenueLink';
import NotFound from './pages/NotFound';
import Venues from './pages/Venues';
import Refer from './pages/Refer';
import FixtureSimulator from './pages/FixtureSimulator';
import PixelTracker from './components/PixelTracker';

function App() {
  return (
    <Router>
      <PixelTracker />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/open" element={<Open />} />
          <Route path="/i/:token" element={<Invite />} />
          <Route path="/l/:slug" element={<VenueLink />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/recomienda" element={<Refer />} />
          <Route path="/simulador" element={<FixtureSimulator />} />
          <Route path="/simulator" element={<FixtureSimulator />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
